import styled from "styled-components";

export const StyledV2Footer = styled.footer`
  width: 100%;
  max-width: 500px;
  margin: ${(props) => (props.stickyBottom ? "0" : "2.5rem auto 0")};
  padding: ${(props) =>
    props.stickyBottom
      ? "10px 1.25rem calc(10px + env(safe-area-inset-bottom, 0px))"
      : "10px 1.25rem"};
  box-shadow: ${(props) =>
    props.stickyBottom ? "0 -10px 24px rgba(29, 42, 64, 0.08)" : "none"};
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
  border-top: ${(props) => (props.stickyBottom ? "1px solid var(--rms-v2-border-soft, #eef2f7)" : "none")};
  border-radius: ${(props) => (props.stickyBottom ? "14px 14px 0 0" : "0")};
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.stickyBottom ? "space-between" : "center")};
  font-size: 13px;
  text-align: center;
  z-index: 7;
  position: ${(props) => (props.stickyBottom ? "fixed" : "relative")};
  left: ${(props) => (props.stickyBottom ? "50%" : "auto")};
  bottom: ${(props) => (props.stickyBottom ? "0" : "auto")};
  transform: ${(props) => (props.stickyBottom ? "translateX(-50%)" : "none")};

  .footer-help {
    color: var(--rms-v2-text-title, #111827);
    font-weight: 700;
    text-decoration: underline;
  }

  .footer-powered {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    font-size: 10px;
  }

  .footer-powered a {
    display: inline-flex;
    margin-left: 5px;
  }

  .footer-powered img {
    display: block;
    width: 86px;
    height: auto;
  }
`;
